import GlobalStore from '../GlobalStore'

export const INNOPAY_PAY_METHOD = {
    CARD : 'CARD',
    KAKAO : 'EPAY',
    NAVER : 'EPAY'
}

var InnoPay = (function(){
    const innopay = window.innopay || {};
    // const MID = "testpay01m";
    // const LICENSE_KEY = "Ma29gyAFhvv/+e4/AHpV6pISQIvSKziLIbrNoXPbRS5nfTx2DOs8OJve+NzwyoaQ8p9Uy1AN4S1I0Um5v7oNUg==";
    // const MID = "pgobyung1m";
    // const LICENSE_KEY = "KIlLd/xVervh9CIrceWciplINkAJ4NFPKZvOi5DjPeNy2iW6fZJ3D4oMf1x2R9wzx0Uq5jOsOlMLWjs8IRD/YA==";
    let MID = "pgschow01m";
    let LICENSE_KEY = "mIFEAEHOMGF3Xuf/9XW97d2NzTW/nsBzxq/uaVIbrG1mwNp7XyI9BdZirU1uiwrdn3f/0K71eZM33Qj8kxhrqw==";
    // const RETURN_URL = process.env.VUE_APP_TEST_URL + "/api/payResultCallback";

    if (process.env.NODE_ENV === 'development'){
        MID = "testpay01m";
        LICENSE_KEY = "Ma29gyAFhvv/+e4/AHpV6pISQIvSKziLIbrNoXPbRS5nfTx2DOs8OJve+NzwyoaQ8p9Uy1AN4S1I0Um5v7oNUg==";
    }

    var _obj = {};
    /**
     * 필수값
     * payMethod : 지불수단 -  CARD: 신용카드
     BANK:계좌이체
     VBANK:가상계좌
     CARS:ARS결제요청
     CSMS:SMS결제 인증
     DSMS:SMS결제 비인증
     EPAY:간편결제 인증
     EBANK:계좌간편결제 인증
     * goodsName : 제품명
     * amt : 거래금액
     * buyerName : 구매자 이름
     * buyerTel : 구매자 전화번호
     * buyerEmail : 구매자 이메일
     * resultYN : 결과창 유무 : Y | N
     * moid : 상점 주문번호 (공유값)
     *
     * 옵션값 (options에 추가)
     * GoodsCnt : 상품개수 : 1
     * 기타 메뉴얼 참고
     *
     * 사용자 정의 데이터 (userData)
     * 임의의 정의 데이터
     */
    _obj.goPay = function(payMethod, goodsName, amt, buyerName, buyerTel, buyerEmail, moid, resultYN, options, userData) {
        console.log("payTest function");
        options = options || {};
        let payData = {'MID':MID,
            'MerchantKey':LICENSE_KEY,
            // 'ReturnURL':RETURN_URL,
            'PayMethod':payMethod || "CARD",
            'GoodsName':goodsName || "테스트 상품",
            'Amt': amt || "1",
            'BuyerName': buyerName || '구매자 명',
            'BuyerTel': buyerTel || '구매자 전화번호',
            'BuyerEmail': buyerEmail || "구매자 전화번호",
            'Moid':moid,
            'ResultYN':resultYN,
            'MallReserved':userData || "",
            // callback:window.PayComplete,
        }

        window.innopay_result = function(data) {
            window.PayComplete(data);
        }

        if(window.Android !== undefined) {
            console.log("android");
            window.Android.goPay(JSON.stringify(payData));
        }else if(window.webkit !== undefined && window.webkit.messageHandlers !== undefined && window.webkit.messageHandlers.ios !== undefined){
            console.log("ios");
            window.webkit.messageHandlers.ios.postMessage({cmd : 'goPay', data: payData});
        }else{
            console.log("windows");
            innopay.goPay({...payData,...options});
        }
    }

    _obj.goPayIntergrated = function(payMethod, goodsName, amt, buyerName, buyerTel, buyerEmail, moid, resultYN, options, userData, callback_second) {
        options = options || {};
        let payData = {'MID':MID,
            'MerchantKey':LICENSE_KEY,
            // 'ReturnURL':RETURN_URL,
            'PayMethod':payMethod || "CARD",
            'GoodsName':goodsName || "테스트 상품",
            'Amt': amt || "1",
            'BuyerName': buyerName || '구매자 명',
            'BuyerTel': buyerTel || '구매자 전화번호',
            'BuyerEmail': buyerEmail || "구매자 전화번호",
            'Moid':moid,
            'ResultYN':resultYN,
            'MallReserved':userData || "",
            // callback:window.PayComplete,
        }

        window.PayComplete = async (result) => {
            let code;
            let dataStr;

            if(window.Android !== undefined) {
                const pattern = /^{"code":(0|-1),"(data|message)":"(.*)"}$/gis;
                if(!pattern.test(result)){
                    GlobalStore.hideProgress();
                    GlobalStore.showAlert('오류가 발생했습니다.');
                    return;
                }
                code = RegExp.$1;
                dataStr = RegExp.$3;
            }else if(window.webkit !== undefined && window.webkit.messageHandlers !== undefined && window.webkit.messageHandlers.ios !== undefined){
                const resultObj = JSON.parse(result);
                code = resultObj.code;
                if(resultObj.code == 0){
                    dataStr = JSON.stringify(resultObj.data);
                }else if(resultObj == -1){
                    dataStr = JSON.stringify(resultObj.message);
                }
            }else {
                code = 0;
                dataStr = JSON.stringify(result);
            }

            if(code != '0'){
                if(!(dataStr == null || dataStr === 'canceled')){
                    GlobalStore.showAlert(dataStr);
                }
                GlobalStore.hideProgress();
                return;
            }

            const dataObj = JSON.parse(dataStr);

            if(dataObj.ResultCode != "3001") {
                GlobalStore.showAlert(dataObj.ErrorMsg);
                GlobalStore.hideProgress();
                return;
            }

            callback_second(dataStr);
        }

        window.innopay_result = function(data) {
            // console.log('innopay_result called', data);
            window.PayComplete(data);
        }

        if(window.Android !== undefined) {
            console.log("android");
            window.Android.goPay(JSON.stringify(payData));
        }else if(window.webkit !== undefined && window.webkit.messageHandlers !== undefined && window.webkit.messageHandlers.ios !== undefined){
            console.log("ios");
            window.webkit.messageHandlers.ios.postMessage({cmd : 'goPay', data: payData});
        }else{
            payData.Amt = '' + payData.Amt;
            console.log("windows");
            innopay.goPay({...payData,...options});
        }
    }

    _obj.isSuccess = function(res) {
        console.log("pay success check : "+res);
        const resultCode = res.resultCode;
        console.log("resultCode = "+resultCode);
        const SUCCESS = ["3001","4000","4100","3001","0000"];
        if(SUCCESS.includes(resultCode)) {
            return true;
        }
        return false;

    }
    return _obj;
})();
export default InnoPay
